import './options.css';
import { useState } from 'react';
import axios from 'axios';
import { SquaredIcon } from '../components/squaredIcon';
import { ReactComponent as SaveSVG } from '../images/saveProceeding.svg';
import { useAuth } from '../context/context';
import { post } from './utils/utils';

export function Options() {
  const [userPassword, setUserPassword] = useState('');
  const [userPasswordConfirm, setUserPasswordConfirm] = useState('');
  const [adminPassword, setAdminPassword] = useState('');
  const [adminPasswordConfirm, setAdminPasswordConfirm] = useState('');
  const { user } = useAuth();

  function putNewPassword(username: string, password: string, passwordConfirm: string) {

    if(password !== passwordConfirm) {
        alert('Las contraseñas no coinciden.');
        return;
    }

    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);

    if(user && user.token) {
        post({
          url: 'putCredentials.php',
          data: formData,
          token: user.token
        })
          .then((response) => response.data)
          .then((data) => {
            if (data.status === 'ok') {
              alert('Contraseña actualizada correctamente.');
            }
          });
    }

  }

  function putAdminPassword(event: React.SyntheticEvent<HTMLFormElement>) {
    event.preventDefault();
    putNewPassword('admin', adminPassword, adminPasswordConfirm);
  }

  function putUserPassword(event: React.SyntheticEvent<HTMLFormElement>) {
    event.preventDefault();
    putNewPassword('alumno', userPassword, userPasswordConfirm);
  }

  return (
    <div className="options-container">
        <form onSubmit={putAdminPassword} className='options-new-item'>
          <strong>Administrador</strong>
          <div className="options-new-item-input">
            <label htmlFor="admin-password">Contraseña: </label>
            <input
              type="password"
              required
              id="admin-password"
              className="agenda-input"
              placeholder="Contraseña admin"
              value={adminPassword}
              onChange={(event) => setAdminPassword(event.target.value)}
            />
          </div>
          <div className="options-new-item-input">
            <label htmlFor="admin-confirm">Confirmar contraseña: </label>
            <input
              type="password"
              required
              id="admin-confirm"
              className="agenda-input"
              placeholder="Confirmar contraseña"
              value={adminPasswordConfirm}
              onChange={(event) => setAdminPasswordConfirm(event.target.value)}
            />
          </div>
          <div className='proceedings-submit'>
                <p>Actualizar</p>
                <button type='submit'>
                    <SquaredIcon icon={<SaveSVG className='clickable' />} />
                </button>
            </div>
        </form>

        <div className="proceedings-section-line"></div>
        <form onSubmit={putUserPassword} className='options-new-item'>
          <strong>Usuario</strong>
          <div className="options-new-item-input">
            <label htmlFor="user-password">Contraseña: </label>
            <input
              required
              type="password"
              className="agenda-input"
              placeholder="Contraseña usuario"
              id="user-password"
              value={userPassword}
              onChange={(event) => setUserPassword(event.target.value)}
            />
          </div>
          <div className="options-new-item-input">
            <label htmlFor="user-confirm">Confirmar contraseña: </label>
            <input
              required
              type="password"
              className="agenda-input"
              placeholder="Confirmar contraseña"
              id="confirm"
              value={userPasswordConfirm}
              onChange={(event) => setUserPasswordConfirm(event.target.value)}
            />
          </div>
          <div className='proceedings-submit'>
                <p>Actualizar</p>
                <button type='submit'>
                    <SquaredIcon icon={<SaveSVG className='clickable' />} />
                </button>
            </div>
        </form>
    </div>
  );
}
